import { onMounted, ref } from 'vue'
import { getToDoList } from '@/api/home/index.js'

const sysToDoListNumber = ref(0)

export const useSysHeaderToDoListNumber = () => {
  const refresh = async () => {
    const { result } = await getToDoList({ status: 0 })
    if (result) sysToDoListNumber.value = result.data.total
  }
  onMounted(() => refresh())
  return { sysToDoListNumber, refresh }
}

